import type { Route } from "next";
import { type WorkspaceScope, buildRoute } from "./shared";

export const apiKeyRoutes = {
  list({ workspaceSlug }: WorkspaceScope): Route {
    return buildRoute("/[workspaceSlug]/api-keys", { workspaceSlug });
  },
};
